module.exports = __webpack_public_path__ + "static/media/zac-grisham.44b4031c.jpg";